module.exports = __webpack_public_path__ + "static/media/hc1.934c8571.jpg";